import { Grid, Modal } from "@mui/material";
import { useEffect, useState } from "react";
import { AcctionButtons } from "../CompletionPage/AcctionButtons";
import { CustomField } from "../Address/CustomField";
import { useForm } from "react-hook-form";
import { getFeildInfo } from "../CompletionPage/AddressModal/hooks";
import { useAppDispatch, useAppSelector } from "../../redux";
import { addNewUserAction, getAllRolesAction, selectRoles } from "../Dashboard/DashboardSlice";
import type { IErrors } from "../Address/types";
import { selectText } from "../LanguageSelect/LanguageSelectSlice";
import { useStyles } from "../CompletionPage/ModalHooks";

interface NewUserProps {
  handleClose(): void;
  success: string | null;
  isOpen: boolean;
}

export interface NewUser {
  username: string;
  password: string;
  role_id: number;
}

export function NewUser(props: NewUserProps) {
  const { isOpen, success, handleClose } = props;
  const [errors, setErrors] = useState<IErrors>({});
  const { register, handleSubmit, reset } = useForm({
    mode: "onBlur",
  });
  const { modalStyle } = useStyles();

  const roles = useAppSelector(selectRoles);
  const text = useAppSelector(selectText);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const start = async () => {
      async function getData() {
        await dispatch(getAllRolesAction());
      }

      await getData();
    };

    start();
  }, []);

  if (!roles) return null;
  const newUserFields = getFeildInfo(text, "new_user", roles);

  const addNewUser = async (data: any) => {
    const validation = formValidation(data);
    if (!validation) {
      return;
    }

    const user: NewUser = {
      username: data.username,
      password: data.password,
      role_id: data.role,
    };

    await dispatch(addNewUserAction(user));
    handleClose();
    reset();
  };

  const formValidation = (data: { [key: string]: any }) => {
    let fields_errors = { ...errors };
    Object.keys(data).forEach(function (key, index) {
      fields_errors[key] = { err: false, msg: "" };

      let value = data[key] ? !data[key].toString().trim() : true;
      let msg = value ? "Required Field" : "";
      const error = { err: value, msg: msg };
      fields_errors[key] = error;
      setErrors(fields_errors);
    });

    let validation: boolean = true;
    Object.keys(fields_errors).map((key) => {
      if (fields_errors[key].err === true) {
        validation = false;
        return;
      }
      return;
    });
    return validation;
  };

  return (
    <Modal
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Grid sx={modalStyle} container spacing={3} direction="row" justifyContent="flex-start" alignItems="center">
        <form
          onSubmit={(e: any) => {
            e.preventDefault();
            handleSubmit(addNewUser)(e);
          }}
        >
          <Grid container spacing={2}>
            {newUserFields.map((feild, i) => {
              const key: string = feild.name;
              return (
                <CustomField
                  {...register(key)}
                  key={i}
                  feild={feild}
                  error={errors[`${feild.name}`]?.err}
                  err_msg={errors[`${feild.name}`]?.msg}
                />
              );
            })}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid container>
                <AcctionButtons handleClose={handleClose} action={() => {}} type="submit" title={"Add New User"} />
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Modal>
  );
}
